"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { logout } from "@/actions/auth.action";
import ChevronDown from "@/components/icons/chevron-down";
import { cn } from "@/lib/utils";

const ArticleIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Makale</title>
    <path
      d="M22 4.67068V16.7407C22 17.7007 21.22 18.6007 20.26 18.7207L19.93 18.7607C17.75 19.0507 14.39 20.1607 12.47 21.2207C12.21 21.3707 11.78 21.3707 11.51 21.2207L11.47 21.2007C9.54997 20.1507 6.20003 19.0507 4.03003 18.7607L3.73999 18.7207C2.77999 18.6007 2 17.7007 2 16.7407V4.66067C2 3.47067 2.96997 2.57068 4.15997 2.67068C6.25997 2.84068 9.43997 3.9007 11.22 5.0107L11.47 5.16067C11.76 5.34067 12.24 5.34067 12.53 5.16067L12.7 5.05068C13.33 4.66068 14.13 4.27068 15 3.92068V8.00069L17 6.67068L19 8.00069V2.78072C19.27 2.73072 19.53 2.70069 19.77 2.68069H19.83C21.02 2.58069 22 3.47068 22 4.67068Z"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M12 5.48999V20.49"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M19 2.78003V8L17 6.66998L15 8V3.91998C16.31 3.39998 17.77 2.98003 19 2.78003Z"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

const ForumIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Forum</title>
    <path
      d="M17.9981 7.15952C17.9381 7.14952 17.8681 7.14952 17.8081 7.15952C16.4281 7.10952 15.3281 5.97951 15.3281 4.57951C15.3281 3.14951 16.4781 1.99951 17.9081 1.99951C19.3381 1.99951 20.4881 3.15951 20.4881 4.57951C20.4781 5.97951 19.3781 7.10952 17.9981 7.15952Z"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M16.9675 14.4394C18.3375 14.6694 19.8475 14.4294 20.9075 13.7194C22.3175 12.7794 22.3175 11.2394 20.9075 10.2994C19.8375 9.58943 18.3075 9.34942 16.9375 9.58942"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M5.97438 7.15952C6.03438 7.14952 6.10438 7.14952 6.16438 7.15952C7.54438 7.10952 8.64437 5.97951 8.64437 4.57951C8.64437 3.14951 7.49438 1.99951 6.06438 1.99951C4.63438 1.99951 3.48438 3.15951 3.48438 4.57951C3.49437 5.97951 4.59438 7.10952 5.97438 7.15952Z"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M6.9975 14.4394C5.6275 14.6694 4.1175 14.4294 3.0575 13.7194C1.6475 12.7794 1.6475 11.2394 3.0575 10.2994C4.1275 9.58943 5.6575 9.34942 7.0275 9.58942"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M11.9981 14.6302C11.9381 14.6202 11.8681 14.6202 11.8081 14.6302C10.4281 14.5802 9.32812 13.4502 9.32812 12.0502C9.32812 10.6202 10.4781 9.47021 11.9081 9.47021C13.3381 9.47021 14.4881 10.6302 14.4881 12.0502C14.4781 13.4502 13.3781 14.5902 11.9981 14.6302Z"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M9.08875 17.7801C7.67875 18.7201 7.67875 20.2601 9.08875 21.2001C10.6888 22.2701 13.3087 22.2701 14.9087 21.2001C16.3187 20.2601 16.3187 18.7201 14.9087 17.7801C13.3187 16.7201 10.6888 16.7201 9.08875 17.7801Z"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

const TvIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>TV</title>
    <path
      d="M4 12.0004V8.44038C4 4.02038 7.13 2.21038 10.96 4.42038L14.05 6.20038L17.14 7.98038C20.97 10.1904 20.97 13.8104 17.14 16.0204L14.05 17.8004L10.96 19.5804C7.13 21.7904 4 19.9804 4 15.5604V12.0004Z"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
  </svg>
);

const QuizIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Quiz</title>
    <path
      d="M12.3672 8.87988H17.6172"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M6.38281 8.87988L7.13281 9.62988L9.38281 7.37988"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M12.3672 15.8789H17.6172"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M6.38281 15.8789L7.13281 16.6289L9.38281 14.3789"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M9 21.998H15C20 21.998 22 19.998 22 14.998V8.99805C22 3.99805 20 1.99805 15 1.99805H9C4 1.99805 2 3.99805 2 8.99805V14.998C2 19.998 4 21.998 9 21.998Z"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

const GuideIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Alışveriş Rehberi</title>
    <path
      d="M8 2H6C4.9 2 4 2.9 4 4L3 20H21L20 4C20 2.9 19.1 2 18 2H16"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M16 6C16 8.21 14.21 10 12 10C9.79 10 8 8.21 8 6"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M8 2H16"
      stroke="#0091D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

const BookmarkIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Bookmark</title>
    <g clipPath="url(#clip0_9655_75378)">
      <path
        d="M4.5 20.2499C4.5 19.6532 4.73705 19.0809 5.15901 18.6589C5.58096 18.237 6.15326 17.9999 6.74999 17.9999H19.4999V6C19.4999 4.34315 18.1568 3 16.4999 3H6.74999C6.15326 3 5.58096 3.23705 5.15901 3.65901C4.73705 4.08096 4.5 4.65326 4.5 5.24999V20.2499Z"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16.5 3.5V12L13.4991 9.875L10.5 12V3.5"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M4.5 20.25V21H17.9999"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_9655_75378">
        <rect fill="white" height="24" width="24" />
      </clipPath>
    </defs>
  </svg>
);

const navItems = [
  {
    description: "Beğeni, yorum, yanıt ve favoriler",
    href: "/profile/article",
    icon: <ArticleIcon />,
    title: "Makale",
  },
  {
    description: "Beğeni, yorum ve favoriler",
    href: "/profile/guide",
    icon: <GuideIcon />,
    title: "Alışveriş Rehberi",
  },
  {
    description: "Konular, beğeni, yorum, yanıt ve favoriler",
    href: "/profile/forum",
    icon: <ForumIcon />,
    title: "Forum",
  },
  {
    description: "Beğeni, yorum, yanıt ve favoriler",
    href: "/profile/tv",
    icon: <TvIcon />,
    title: "bebek.com TV",
  },
  {
    description: "Beğeni, yorum, yanıt ve favoriler",
    href: "/profile/quiz",
    icon: <QuizIcon />,
    title: "Quiz",
  },
  {
    description: "Beğendiğiniz isimler",
    href: "/profile/names",
    icon: <BookmarkIcon />,
    title: "Favori İsimler",
  },
];

const ProfileSidebar = () => {
  const pathname = usePathname();

  return (
    <nav className="flex flex-col gap-1">
      <ul className="list-none flex flex-col gap-1">
        {navItems.map((item) => {
          const isActive = pathname.startsWith(item.href);
          return (
            <li key={item.href}>
              <Link
                className={cn(
                  "flex flex-row items-center gap-3 px-3 py-3 rounded-xl transition-colors hover:bg-brand-blue-50",
                  isActive && "bg-brand-blue-50",
                )}
                href={item.href}
              >
                <div
                  className={cn(
                    "size-10 shrink-0 flex items-center justify-center rounded-2xl",
                    isActive ? "bg-brand-blue-100 text-brand-blue-600" : "",
                  )}
                >
                  {item.icon}
                </div>
                <div className="flex flex-col flex-1 min-w-0">
                  <span
                    className={cn(
                      "text-sm leading-5 font-bold",
                      isActive && "text-brand-blue-600",
                    )}
                  >
                    {item.title}
                  </span>
                  <span className="text-xs leading-4 font-medium text-neutral-500 truncate">
                    {item.description}
                  </span>
                </div>
                <ChevronDown className="size-4 rotate-270 stroke-neutral-400 fill-none shrink-0" />
              </Link>
            </li>
          );
        })}
      </ul>

      <div className="border-t border-gray-300 py-2 px-2">
        <form action={logout}>
          <button
            className="flex flex-row items-center gap-2 px-3 py-2 text-sm font-semibold text-neutral-500 hover:text-red-500 transition-colors cursor-pointer"
            type="submit"
          >
            <svg
              fill="none"
              height="24"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Çıkış Yap</title>
              <path
                d="M8.89844 7.55999C9.20844 3.95999 11.0584 2.48999 15.1084 2.48999H15.2384C19.7084 2.48999 21.4984 4.27999 21.4984 8.74999V15.27C21.4984 19.74 19.7084 21.53 15.2384 21.53H15.1084C11.0884 21.53 9.23844 20.08 8.90844 16.54"
                stroke="#0091D5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <path
                d="M14.9972 12H3.61719"
                stroke="#0091D5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <path
                d="M5.85 8.6499L2.5 11.9999L5.85 15.3499"
                stroke="#0091D5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
            </svg>
            Çıkış Yap
          </button>
        </form>
      </div>
    </nav>
  );
};

export default ProfileSidebar;
